import { SvgIconProps, TypographyProps } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { BannerLabelText, StyledBannerContainer } from './Banner.style';
import { TextProps } from '@components/Text/Text';
import { ColorTypes } from '@customTypes/colors';

interface PropsType extends PropsWithChildren {
  color: ColorTypes;
  icon?: (props: SvgIconProps) => JSX.Element;
  textProps?: TextProps & Omit<TypographyProps, 'fontWeight'>;
  iconTestId?: string;
}

const Banner: React.FC<PropsType> = ({
  children,
  color = 'warning',
  icon: Icon,
  textProps,
  iconTestId = 'Banner-Icon',
}) => {
  return (
    <StyledBannerContainer colorType={color}>
      {Icon && <Icon color={color} id={iconTestId} />}
      <BannerLabelText
        variant='h6'
        fontWeight='fontWeightRegular'
        colorType={color}
        isIcon={!!Icon}
        {...textProps}
      >
        {children}
      </BannerLabelText>
    </StyledBannerContainer>
  );
};
export default Banner;
